import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  fabMeetingNotifications: [],
  unseenMeetingCount: 0,
};

const meetingNotificationSlice = createSlice({
  name: 'meetingNotifications',
  initialState,
  reducers: {
    receiveMeetingEvent: (state, action) => {
      const event = action.payload;
      if (!event?.type || !event?.appointmentId) return;

      const type = String(event.type).toUpperCase();
      if (!type.startsWith('MEETING_')) return;

      const fabKey = `${type}-${event.appointmentId}-${event.triggeredAt || event.date || ''}`;
      const exists = state.fabMeetingNotifications.some((n) => n.fabKey === fabKey);
      if (exists) return;

      state.fabMeetingNotifications.unshift({
        fabKey,
        type,
        appointmentId: event.appointmentId,
        channelId: event.channelId,
        chatMessageId: event.chatMessageId,
        title: event.title || 'Meeting',
        date: event.date,
        startTime: event.startTime,
        endTime: event.endTime,
        meetingLink: event.meetingLink,
        notificationTitle: event.notificationTitle,
        notificationBody: event.notificationBody,
        receivedAt: new Date().toISOString(),
      });
      if (state.fabMeetingNotifications.length > 30) {
        state.fabMeetingNotifications.length = 30;
      }
      state.unseenMeetingCount += 1;
    },
    markMeetingEventsSeen: (state) => {
      state.unseenMeetingCount = 0;
    },
    dismissFabMeetingNotification: (state, action) => {
      const fabKey = action.payload;
      state.fabMeetingNotifications = state.fabMeetingNotifications.filter(
        (n) => n.fabKey !== fabKey,
      );
    },
    clearAllFabMeetingNotifications: (state) => {
      state.fabMeetingNotifications = [];
      state.unseenMeetingCount = 0;
    },
  },
});

export const {
  receiveMeetingEvent,
  markMeetingEventsSeen,
  dismissFabMeetingNotification,
  clearAllFabMeetingNotifications,
} = meetingNotificationSlice.actions;

export default meetingNotificationSlice.reducer;
